import React from 'react';
import clsx from 'clsx';

import { BracketsProps } from '../Brackets/Brackets.types';
import { ImageProps } from '../Image/Image.types';
import { IconProps } from '../Icon/Icon.types';
import { BracketItem } from './BracketItem';

export const Brackets = ({
  bracketContents,
  showAsList,
  contentStacked,
}: BracketsProps): JSX.Element => {
  if (!bracketContents) {
    return null;
  }

  const hasImages =
    bracketContents[0].headMedia &&
    (bracketContents[0].headMedia as ImageProps).img?.src;
  const hasIcons =
    !hasImages &&
    bracketContents[0].headMedia &&
    (bracketContents[0].headMedia as IconProps).icon
      ? true
      : false;

  return (
    <div
      className={clsx('bracket__group', {
        bracket_icons: hasIcons,
        bracket_list: showAsList,
        'bracket-col_3': !showAsList && bracketContents.length % 2 !== 0,
        'bracket-col_4': !showAsList && bracketContents.length % 2 === 0,
        bracket_stack: contentStacked,
      })}
    >
      {bracketContents.map(
        ({ headingText, leadText, headMedia, titleAsHeading }, index) => {
          return (
            <BracketItem
              headingText={headingText}
              leadText={leadText}
              headMedia={headMedia}
              titleAsHeading={titleAsHeading}
              key={index}
            />
          );
        }
      )}
    </div>
  );
};
